export default [{
    name: 'dashboard',
    children: [
        {
            name: 'ManageFlightflightticket',
            path: '/manage/flight/policy/flightticket',
            component: resolve => require(['./policy/flightticket.vue'], resolve)
        }, {
            name: 'ManageFlightPolicyUpdate',
            path: '/manage/flight/policy/update',
            component: resolve => require(['./policy/update.vue'], resolve)
        },
        {
            name: 'ManageFlightPolicyUpdate',
            path: '/manage/:service?/salesStrategy/list',
            component: resolve => require(['./policy/salesStrategy/list.vue'], resolve)
        },
        {
            name: 'ManageFlightPolicyUpdate',
            path: '/manage/:service?/salesStrategy/detail',
            component: resolve => require(['./policy/salesStrategy/detail.vue'], resolve)
        },
        {
            name:'rulepolicy',
            path:'/manage/flight/rulepolicy',
            component:resolve=>require(['./rulepolicy/list.vue'],resolve)
        }
        ,
        {
            name:'notifyrulepolicy',
            path:'/manage/flightpolicy/notifyrule',
            component:resolve=>require(['./notify/list.vue'],resolve)
        }
        ,
        {
            name:'notifyrulepolicyupdate',
            path:'/manage/flightpolicy/flightnotifyupdate',
            component:resolve=>require(['./notify/update.vue'],resolve)
        }
    ]
}]



// WEBPACK FOOTER //
// ./src/views/manage/flight/router.js